import { render, staticRenderFns } from "./CampaignSummaryTable.vue?vue&type=template&id=6de23018&"
import script from "./CampaignSummaryTable.vue?vue&type=script&lang=js&"
export * from "./CampaignSummaryTable.vue?vue&type=script&lang=js&"
import style0 from "./CampaignSummaryTable.vue?vue&type=style&index=0&id=6de23018&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports